import Exhibitions from './Exhibitions.svelte'
import Winners from './Winners.svelte'

const exhibitionsEl = document.querySelector('#exhibitions-app')
const winnersEl = document.querySelector('#winners-app')

if (exhibitionsEl) {
	new Exhibitions({
		target: document.querySelector('#exhibitions-app')
	})
}

if (winnersEl) {
	new Winners({
		target: winnersEl
	})
}